import React from "react";
import { useTransactionsController } from "./useTransactionsController";
import { TransactionsHeader } from "./components/TransactionsHeader";
import { TransactionsCard } from "./components/TransactionsCard";
import { ReportingPeriodTimeline } from "../reporting-periods";

export const Transactions = () => {
  const controller = useTransactionsController();

  return (
    <div className="w-full">
      <TransactionsHeader
        onAddTransaction={() => controller.openModal("add")}
      />

      <ReportingPeriodTimeline />

      <TransactionsCard
        searchQuery={controller.searchQuery}
        setSearchQuery={controller.setSearchQuery}
        isLoading={controller.isLoading}
        filteredTransactions={controller.filteredTransactions}
        onViewTransaction={(transaction) =>
          controller.openModal("view", transaction)
        }
        onConfirmTransaction={controller.confirmTransaction}
        onDeleteTransaction={controller.deleteTransaction}
      />

      {/* Modal components would go here once implemented */}
    </div>
  );
};
